const SCRIPT_URL = 'https://tags.tiqcdn.com/utag/vodafone/za-rugby-zone/prod/utag.js';

let injection = null;

// Appends utag.js once per page load. Every call returns the same promise, which settles
// once the script has loaded or failed, so callers can safely wait on it.
export function injectScript() {
    if (injection) return injection;

    // utagDataPost sends a view for every route, the landing route included, so stop utag.js
    // firing its own automatic view on load — that counted the landing page twice.
    window.utag_cfg_ovrd = window.utag_cfg_ovrd || {};
    window.utag_cfg_ovrd.noview = true;

    injection = new Promise((resolve, reject) => {
        const scriptElement = document.createElement('script');

        scriptElement.src = SCRIPT_URL;
        scriptElement.type = 'text/javascript';
        scriptElement.async = true;

        scriptElement.onload = () => resolve();
        scriptElement.onerror = () => reject(new Error('Script load error'));

        const firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(scriptElement, firstScript);
    }).catch((error) => {
        // Settle rather than retry: a blocked CDN must not re-inject on every call,
        // which is the bug this guard exists for.
        console.error('Failed to load the script:', error);
    });

    return injection;
}
